import React, { useContext, useState } from "react";
import {
  Item,
  Button,
  Label,
  Segment,
  Table,
  Menu,
  Icon,
  Confirm,
  Container,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import FttcHourStore from "../../../app/stores/fttchourStore";
import { Link } from "react-router-dom";

const FttcHourList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [fttchourId, setFttcHourId] = useState("");
  const fttchourStore = useContext(FttcHourStore);
  const {
    fttchournamesByDate: fttchournamesByDate,
    deleteFttcHour: deleteFttcHour,
    submitting,
    target,
  } = fttchourStore;

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Work Order</Table.HeaderCell>
          <Table.HeaderCell>SOR</Table.HeaderCell>
          <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
          <Table.HeaderCell>Amount</Table.HeaderCell>
          <Table.HeaderCell>Technician</Table.HeaderCell>
          <Table.HeaderCell>Start Date</Table.HeaderCell>
          <Table.HeaderCell>Comment</Table.HeaderCell>
          <Table.HeaderCell width={1}>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {fttchournamesByDate.map((fttchour) => {
          return (
            <Table.Row key={fttchour.id}>
              <Table.Cell>{fttchour.financialYear}</Table.Cell>
              <Table.Cell>{fttchour.payRun}</Table.Cell>

              <Table.Cell>{fttchour.workOrder}</Table.Cell>
              <Table.Cell>{fttchour.sorId}</Table.Cell>
              <Table.Cell>{fttchour.description}</Table.Cell>
              <Table.Cell>{fttchour.amount}</Table.Cell>
              <Table.Cell>{fttchour.tech}</Table.Cell>
              <Table.Cell>
                {fttchour.startDate &&
                  fttchour.startDate.substr(8, 2) +
                    "/" +
                    fttchour.startDate.substr(5, 2) +
                    "/" +
                    fttchour.startDate.substr(0, 4)}
              </Table.Cell>
              <Table.Cell>{fttchour.comment}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    as={Link}
                    to={`/financemanagement/fttchour-edit/${fttchour.id}`}
                    size="mini"
                    icon="edit"
                    color="blue"
                    title="Edit"
                  />
                  <Button
                    name={fttchour.id}
                    size="mini"
                    loading={target === fttchour.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setFttcHourId(fttchour.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteFttcHour(fttchourId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>

      <Table.Footer></Table.Footer>
    </Table>
  );
};

export default observer(FttcHourList);
